// extracted by css-extract-rspack-plugin
export default {"btnNew":"VadKNnGZUjQIk7oa","btnNewBlue":"qOi330yPe64iVJWY","btnNewPurple":"vBZQ7fHQxrc3z9Y2","changeStatus":"Ddp0bS3qtp871elR","tableWrapper":"IYlQqZlEGpUPTGJZ"};